"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');












var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _bus = require('shared/services/bus'); var _bus2 = _interopRequireDefault(_bus);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _patientApp = require('shared/selectors/patientApp');
var _hooks = require('web/services/hooks');

var _format = require('./format');



var _selection = require('./selection');








// Each view opens on its approved default: Active on Last from patient, the
// Archived view on when patients were archived, newest first.
 const DEFAULT_SORT = {
  active: { sort: 'last_from_patient', desc: true },
  archived: { sort: 'archived_at', desc: true },
}; exports.DEFAULT_SORT = DEFAULT_SORT

// Columns whose first click sorts newest (or Z) first.
const DESC_FIRST = new Set(['created', 'last_from_patient', 'last_to_patient', 'archived_at'])

const SEARCH_DELAY_MS = 300
// The selection's count waits for ticking to settle.
const PREVIEW_DELAY_MS = 300




const NO_KEYS = new Set()







/* What a bulk action on everyone matching would cover, once ticking settles
 * (PreviewPatientSelection): the count the dialogs show, whether the cap cut
 * it short, which rows on the page it covers past the cap, and the patients
 * left out, echoed. An older server refuses the command, and one that
 * ignored LeftOut would act on those patients, so the table runs an action
 * with patients left out only once this has answered (P-1). */
const useSelectionPreview = (orgKey, isArchived, selection, shown) => {
  const request = selection ? JSON.stringify({ Archived: isArchived, Selection: selection, Shown: shown.length ? shown : undefined }) : ''
  const [preview, setPreview] = _react.useState(null)
  const [attempt, setAttempt] = _react.useState.call(void 0, 0)
  _react.useEffect.call(void 0, () => {
    if (!request) return
    let isCurrent = true
    const timer = setTimeout(
      () => _actions2.default.previewPatientSelection({ OrgKey: orgKey, ...JSON.parse(request)  })
        .then(counts => { if (isCurrent) setPreview({ request, counts, hasFailed: false }) })
        .catch(() => { if (isCurrent) setPreview({ request, counts: null, hasFailed: true }) }),
      PREVIEW_DELAY_MS,
    )
    return () => {
      isCurrent = false
      clearTimeout(timer)
    }
  }, [orgKey, request, attempt])
  const retry = _react.useCallback.call(void 0, () => setAttempt(n => n + 1), [])
  const current = _optionalChain([preview, 'optionalAccess', _ => _.request]) === request ? preview : null
  return { counts: _nullishCoalesce(_optionalChain([current, 'optionalAccess', _2 => _2.counts]), () => ( null)), hasFailed: !!_optionalChain([current, 'optionalAccess', _3 => _3.hasFailed]), retry }
}

// Patient changes made outside the table's own actions (adding a patient,
// editing one, changing their texting) reload the open page (review F-4).
 const PATIENT_CHANGE_ACTIONS = [
  _actionCreators2.default.createPatientActions.SUCCESS.type,
  _actionCreators2.default.updatePatientActions.SUCCESS.type,
  _actionCreators2.default.resubscribePatientSMSActions.SUCCESS.type,
  _actionCreators2.default.markPatientSMSOptedOutActions.SUCCESS.type,
  _actionCreators2.default.blockPatientSMSActions.SUCCESS.type,
  _actionCreators2.default.unblockPatientSMSActions.SUCCESS.type,
  _actionCreators2.default.clearPatientSMSUnreachableActions.SUCCESS.type,
]; exports.PATIENT_CHANGE_ACTIONS = PATIENT_CHANGE_ACTIONS

/* The patient table's view, search, filters, sort and page, the page the
 * server returned for them, and the selection. A change to the view, search
 * or filters goes back to page 1 and clears the selection; a reload keeps
 * both (after an action, the open page refreshes in place), unless the page
 * no longer exists, when it moves to the last page there is. */
// beforeShow: called with a loaded page's patients before the table shows
// them (the running archives read their marks, D-61). broadcast: the
// picker's broadcast, whose recipients the list counts, and hides with
// isHidingAdded (Hide already added, D-84); a change to it is a new scope.





 const usePatientTable = (orgKey, beforeShow, broadcast) => {
  const prepare = _react.useRef.call(void 0, beforeShow)
  _react.useEffect.call(void 0, () => { prepare.current = beforeShow }, [beforeShow])
  const [view, setViewState] = _react.useState('active')
  const [search, setSearch] = _react.useState.call(void 0, '')
  const [query, setQuery] = _react.useState.call(void 0, '')
  const [filter, setFilterState] = _react.useState({})
  const [sortState, setSortState] = _react.useState(exports.DEFAULT_SORT.active)
  const [page, setPage] = _react.useState.call(void 0, 0)
  // The page the server returned, and which page it is.
  const [data, setData] = _react.useState(null)
  const [loadedPage, setLoadedPage] = _react.useState.call(void 0, 0)
  const [isLoading, setIsLoading] = _react.useState.call(void 0, true)
  const [hasError, setHasError] = _react.useState.call(void 0, false)
  const [reloads, setReloads] = _react.useState.call(void 0, 0)
  const [selection, setSelection] = _react.useState(_selection.NO_SELECTION)
  // Rows in a running archive or restore: not selectable (D-61).
  const [locked, setLocked] = _react.useState(NO_KEYS)

  // The search waits for typing to pause.
  _react.useEffect.call(void 0, () => {
    const timer = setTimeout(() => setQuery(search.trim()), SEARCH_DELAY_MS)
    return () => clearTimeout(timer)
  }, [search])

  // While the org has the patient app off there is no Patient app group,
  // so its ticks are dropped and never sent.
  const hasPatientApp = _hooks.useAppSelector.call(void 0, state => _patientApp.selectIsPatientAppEnabled.call(void 0, state, orgKey))
  _react.useEffect.call(void 0, () => {
    if (hasPatientApp) return
    setFilterState(f => {
      if (!f.AppUse) return f
      const next = { ...f }
      delete next.AppUse
      return next
    })
  }, [hasPatientApp])

  const fullFilter = _react.useMemo.call(void 0, 
    () => {
      const { AppUse, ...rest } = filter
      return { ...rest, ...(hasPatientApp && _optionalChain([AppUse, 'optionalAccess', _4 => _4.length]) ? { AppUse } : {}), ...(query ? { Query: query } : {}) }
    },
    [filter, query, hasPatientApp],
  )

  const campaignKey = _optionalChain([broadcast, 'optionalAccess', _5 => _5.campaignKey])
  const isHidingAdded = !!_optionalChain([broadcast, 'optionalAccess', _6 => _6.isHidingAdded])

  // A new view, search or filter starts again on page 1 with nothing selected.
  const scopeKey = `${orgKey}|${view}|${JSON.stringify(fullFilter)}|${isHidingAdded}`
  const lastScope = _react.useRef.call(void 0, scopeKey)
  _react.useEffect.call(void 0, () => {
    if (lastScope.current === scopeKey) return
    lastScope.current = scopeKey
    setPage(0)
    setSelection(_selection.NO_SELECTION)
  }, [scopeKey])

  const latest = _react.useRef.call(void 0, 0)
  _react.useEffect.call(void 0, () => {
    const request = ++latest.current
    setIsLoading(true)
    setHasError(false)
    _actions2.default.listOrgPatients({
      OrgKey: orgKey,
      Archived: view === 'archived',
      ...fullFilter,
      Sort: sortState.sort,
      Desc: sortState.desc,
      Offset: page * _format.PAGE_SIZE,
      Limit: _format.PAGE_SIZE,
      ...(campaignKey ? { CampaignKey: campaignKey, HideAdded: isHidingAdded } : {}),
    })
      .then(response => (_nullishCoalesce(_optionalChain([prepare, 'access', _7 => _7.current, 'optionalCall', _8 => _8(response.Patients.map(r => r.PatientKey))]), () => ( Promise.resolve()))).then(() => response))
      .then(response => {
        if (request !== latest.current) return
        setData(response)
        setLoadedPage(page)
        setIsLoading(false)
        // Fewer patients than before (the last ones on the last page were
        // archived): show the last page that has any (review F-5).
        const lastPage = Math.max(0, Math.ceil(response.Total / _format.PAGE_SIZE) - 1)
        if (page > lastPage) setPage(lastPage)
      })
      .catch(() => {
        if (request !== latest.current) return
        setHasError(true)
        setIsLoading(false)
      })
  }, [orgKey, view, fullFilter, sortState, page, reloads, campaignKey, isHidingAdded])

  const setView = _react.useCallback.call(void 0, (next) => {
    setViewState(next)
    setSortState(exports.DEFAULT_SORT[next])
  }, [])

  const setFilter = _react.useCallback.call(void 0, (next) => setFilterState(next), [])

  const onSort = _react.useCallback.call(void 0, (column) => setSortState(current => current.sort === column
    ? { sort: column, desc: !current.desc }
    : { sort: column, desc: DESC_FIRST.has(column) }), [])

  const reload = _react.useCallback.call(void 0, () => setReloads(n => n + 1), [])
  _react.useEffect.call(void 0, () => {
    exports.PATIENT_CHANGE_ACTIONS.forEach(type => _bus2.default.on(type, reload))
    return () => exports.PATIENT_CHANGE_ACTIONS.forEach(type => _bus2.default.off(type, reload))
  }, [reload])

  const rows = _react.useMemo.call(void 0, () => _nullishCoalesce(_optionalChain([data, 'optionalAccess', _9 => _9.Patients]), () => ( [])), [data])
  const total = _nullishCoalesce(_optionalChain([data, 'optionalAccess', _10 => _10.Total]), () => ( 0))

  // The row last ticked or cleared on this page, where a shift-click range
  // starts (D-49).
  const anchor = _react.useRef(null)
  _react.useEffect.call(void 0, () => { anchor.current = null }, [rows])

  // Rows in a running archive or restore can't be selected (D-61).
  const selectable = _react.useMemo.call(void 0, () => rows.map(r => r.PatientKey).filter(key => !locked.has(key)), [rows, locked])

  // Everyone matching is the first 20,000 in the sort, less those in a
  // running archive or restore, which actions leave out (review F-14).
  // The page's count can lag a task that just started; the locked rows on
  // this page inside the 20,000 are running too, so the count never leaves
  // out fewer than those (QA round 9).
  const lockedOnPage = _react.useMemo.call(void 0, 
    () => rows.slice(0, Math.max(0, _format.MAX_PER_ACTION - loadedPage * _format.PAGE_SIZE)).filter(r => locked.has(r.PatientKey)).length,
    [rows, loadedPage, locked],
  )
  const runningCount = Math.max(_nullishCoalesce(_optionalChain([data, 'optionalAccess', _11 => _11.RunningCount]), () => ( 0)), lockedOnPage)
  // How many "All N matching" names: the matches an action can reach.
  const matchingCount = Math.max(0, total - runningCount)

  // Everyone matching (D-84): the server counts it and, past the cap, says
  // which rows on this page it covers.
  const request = _react.useMemo.call(void 0, () => _selection.selectionRequest.call(void 0, selection, fullFilter, sortState), [selection, fullFilter, sortState])
  const isPastCap = selection.isAll && total - selection.leftOut.size > _format.MAX_PER_ACTION
  const shown = _react.useMemo.call(void 0, () => isPastCap ? rows.map(r => r.PatientKey) : [], [isPastCap, rows])
  const preview = useSelectionPreview(orgKey, view === 'archived', selection.isAll ? request : null, shown)
  const chosen = _react.useMemo.call(void 0, () => _optionalChain([preview, 'access', _12 => _12.counts, 'optionalAccess', _13 => _13.Chosen]) ? new Set(preview.counts.Chosen) : null, [preview.counts])

  // Until the server says, the rows before the 20,000th (review F-9) are
  // inside the cap; a patient left out lets the next one in (D-48).
  const capped = _react.useMemo.call(void 0, 
    () => new Set(rows.slice(0, Math.max(0, _format.MAX_PER_ACTION + selection.leftOut.size - loadedPage * _format.PAGE_SIZE)).map(r => r.PatientKey)),
    [rows, loadedPage, selection.leftOut.size],
  )
  const isSelected = _react.useCallback.call(void 0, (key) => {
    // A selection by filter leaves out the locked rows on the server, so they
    // show unticked (D-61).
    if (locked.has(key)) return false
    // A Select all is the filter less the patients left out; rows ticked
    // before it are among its matches.
    if (selection.isAll) {
      if (selection.leftOut.has(key)) return false
      return chosen && isPastCap ? chosen.has(key) : capped.has(key)
    }
    return _selection.isChosen.call(void 0, selection, key)
  }, [locked, selection, chosen, isPastCap, capped])

  // A row that becomes locked leaves the selection.
  _react.useEffect.call(void 0, () => {
    setSelection(s => [...s.picked].some(key => locked.has(key))
      ? { ...s, picked: new Set([...s.picked].filter(key => !locked.has(key))) }
      : s)
  }, [locked])

  const toggle = _react.useCallback.call(void 0, (key, isRange = false) => {
    if (locked.has(key)) return
    const from = isRange && anchor.current ? rows.findIndex(r => r.PatientKey === anchor.current) : -1
    const to = rows.findIndex(r => r.PatientKey === key)
    anchor.current = key
    const range = from >= 0 && to >= 0
      ? rows.slice(Math.min(from, to), Math.max(from, to) + 1).map(r => r.PatientKey)
      : [key]
    const isOn = !isSelected(key)
    // After Select all, unticking leaves patients out (D-84). A row past the
    // cap stays out: an action takes the filter or named patients, not both.
    setSelection(s => _selection.setChosen.call(void 0, s, range.filter(k => !locked.has(k)), isOn))
  }, [rows, locked, isSelected])

  // The header checkbox ticks the page first; its menu and the bar go on to
  // everyone matching (D-84, reversing D-47).
  const headerState = _react.useMemo.call(void 0, () => _selection.pageState.call(void 0, selectable, isSelected), [selectable, isSelected])
  const pressHeader = _react.useCallback.call(void 0, 
    () => setSelection(s => _selection.pressPage.call(void 0, s, selectable, headerState.isChecked)),
    [selectable, headerState.isChecked],
  )
  const selectAllMatching = _react.useCallback.call(void 0, () => setSelection(_selection.selectAll), [])
  const selectPage = _react.useCallback.call(void 0, () => setSelection(_selection.selectOnly.call(void 0, selectable)), [selectable])
  const clearSelection = _react.useCallback.call(void 0, () => setSelection(_selection.NO_SELECTION), [])

  const isCapped = selection.isAll && (_nullishCoalesce(_optionalChain([preview, 'access', _14 => _14.counts, 'optionalAccess', _15 => _15.Capped]), () => ( isPastCap)))
  const estimate = Math.max(0, Math.min(total - selection.leftOut.size, _format.MAX_PER_ACTION) - runningCount)
  const selectedCount = selection.isAll ? (_nullishCoalesce(_optionalChain([preview, 'access', _16 => _16.counts, 'optionalAccess', _17 => _17.Patients]), () => ( estimate))) : selection.picked.size
  const summary = _selection.selectionSummary.call(void 0, selection, matchingCount, selectable, isCapped, selectedCount)
  // An action with patients left out waits for the server to echo them
  // (P-1): a server that ignored LeftOut would act on them.
  const isLeftOutConfirmed = !selection.isAll || selection.leftOut.size === 0 || typeof _optionalChain([preview, 'access', _18 => _18.counts, 'optionalAccess', _19 => _19.LeftOut]) === 'number'

  return {
    view,
    setView,
    search,
    setSearch,
    query,
    filter,
    setFilter,
    fullFilter,
    hasPatientApp,
    sort: sortState,
    onSort,
    page,
    setPage,
    rows,
    total,
    activeCount: _nullishCoalesce(_optionalChain([data, 'optionalAccess', _20 => _20.ActiveCount]), () => ( 0)),
    archivedCount: _nullishCoalesce(_optionalChain([data, 'optionalAccess', _21 => _21.ArchivedCount]), () => ( 0)),
    // Matches already on the broadcast, listed or hidden.
    addedCount: _nullishCoalesce(_optionalChain([data, 'optionalAccess', _22 => _22.AddedCount]), () => ( 0)),
    hasLoaded: data !== null,
    isLoading,
    hasError,
    reload,
    selection,
    hasSelection: _selection.hasAnything.call(void 0, selection),
    selectedCount,
    matchingCount,
    selectableCount: selectable.length,
    isCapped,
    summary,
    selectionRequest: request,
    isLeftOutConfirmed,
    hasPreviewFailed: preview.hasFailed,
    retryPreview: preview.retry,
    isSelected,
    headerState,
    pressHeader,
    setLocked,
    toggle,
    selectAllMatching,
    selectPage,
    clearSelection,
  }
}; exports.usePatientTable = usePatientTable


